window.allowAdd = true
category_count = 0
rule_count = 0

$(document).ready ->

  $('.add-manager-checklist-rule-button').on('click', (e) ->
    e.preventDefault()
    window.allowAdd = false
    element = ''
    l_ids = $('#language_ids').val().split(',')
    ln_id = $(this).data('language-id')
    m_c_id = $(this).data('manager-checklist-type-id')
    category_name = ''
    category_container = ''
    if m_c_id
      category_name = 'manager-checklist'
      category_container = m_c_id
    $(this).parents('.add-category-container').find('.add-category-input').hide()
    $(this).parents('.add-category-container').find('.add-tip-category-button').hide()
    $(this).parents('.add-category-container').find('.add-category-placeholder').show()
    text = $(this).parents('.add-category-container').find('.add-category-input').val()
    if text.length > 0
      $(this).parents('.add-category-container').find('.add-category-input').val('')
      count = parseInt(($(this).parents('form').find('.category-index-number').length / $(this).parents('form').find('#language_ids').val().split(',').length) + 1)
      for l_id in l_ids
        if l_id == ln_id.toString()
          display =  'block'
          textt = text
          span_class = ''
        else
          display = 'none'
          textt = ''
          span_class = 'grayed-out'
        element += "
                    <div class='edit-category-container multi-lanuage-field #{category_name}-category-#{category_container}-#{l_id}' style='display: #{display};'>
                      <span class='category-index-number'>#{count}</span>
                      <span data-name='#{textt}' data-delete='false' class='order-item-name #{span_class}'>#{text}</span>
                      <i class='category-order-icon fa fa-bars right active'></i>
                      <input class='edit-category-input' id='rule_#{rule_count}' name='rule[#{rule_count}][name_multi][#{l_id}]' type='text' value='#{textt}'>
                      <button class='edit-category-button display-none'>edit</button>
                    </div>
                  "
      $("<div class='category-item ui-sortable-handle'>#{element}</div>").insertBefore('#mdl_rules_checklist .edit-categories-main-container .clearfix')
      rule_count--
  )
  $('.add-manager-checklist-category-button').on('click', (e) ->
    e.preventDefault()
    window.allowAdd = false
    element = ''
    l_ids = $('#language_ids').val().split(',')
    ln_id = $(this).data('language-id')
    m_c_id = $(this).data('manager-checklist-type-id')
    category_name = ''
    category_container = ''
    if m_c_id
      category_name = 'manager-checklist'
      category_container = m_c_id
    $(this).parents('.add-category-container').find('.add-category-input').hide()
    $(this).parents('.add-category-container').find('.add-tip-category-button').hide()
    $(this).parents('.add-category-container').find('.add-category-placeholder').show()
    text = $(this).parents('.add-category-container').find('.add-category-input').val()
    if text.length > 0
      $(this).parents('.add-category-container').find('.add-category-input').val('')
      count = parseInt(($(this).parents('form').find('.category-index-number').length / $(this).parents('form').find('#language_ids').val().split(',').length) + 1)
      for l_id in l_ids
        if l_id == ln_id.toString()
          display =  'block'
          textt = text
          span_class = ''
        else
          display = 'none'
          textt = ''
          span_class = 'grayed-out'
        element += "
                    <div class='edit-category-container multi-lanuage-field #{category_name}-category-#{category_container}-#{l_id}' style='display: #{display};'>
                      <span class='category-index-number'>#{count}</span>
                      <span data-name='#{textt}' data-delete='false' class='order-item-name #{span_class}'>#{text}</span>
                      <i class='category-order-icon fa fa-bars right active'></i>
                      <input class='edit-category-input' id='category_#{category_count}' name='category[#{category_count}][category_multi][#{l_id}]' type='text' value='#{textt}'>
                      <button class='edit-category-button display-none'>edit</button>
                    </div>
                  "
      $("<div class='category-item ui-sortable-handle'>#{element}</div>").insertBefore('#mdl_categories_checklist .edit-categories-main-container .clearfix')
      category_count--
  )
